module.exports = __webpack_public_path__ + "img/IMG_1401_L_WoodMatted.1a6fcbdc.jpg";